import {
  MrfiktivReferenceGen,
  MrfiktivVideoMetadataDtoGen,
  MrfiktivVideoMetadataViewModelGen
} from "@/services/mrfiktiv/v1/data-contracts";
import { IReference, Reference } from "./reference.entity";
import { ITag, Tag } from "./tag.entity";

export class VideoMetadata {
  title?: string;
  description?: string;
  tagIds: string[] = [];
  tags: ITag[] = [];
  refs: IReference[] = [];

  constructor(metadata?: MrfiktivVideoMetadataViewModelGen) {
    this.title = metadata?.title ?? "";
    this.description = metadata?.description ?? "";
    this.tagIds = metadata?.tagIds ?? [];
    this.tags = (metadata?.tags ?? []).map(tag => new Tag(tag));
    this.refs = Reference.filterDuplicates((metadata?.refs ?? []).map(ref => new Reference(ref)));
  }

  toDto(): MrfiktivVideoMetadataDtoGen {
    return {
      title: this.title,
      description: this.description,
      tagIds: (this.tagIds ?? []).map(id => id.toString()),
      refs: (this.refs ?? []).map(ref => ({
        refId: ref.refId,
        refType: ref.refType
      })) as MrfiktivReferenceGen[]
    };
  }
}
